import { useState } from 'react';

export const useSet = <T>(
  initial: T[] = [],
  compare?: (a: T, b: T) => boolean
): [T[], (values?: T | T[]) => void, () => void] => {
  const [values, setValues] = useState<T[]>(initial);

  const addRemove = (newValues: T[], newValue: T) => {
    if (compare) {
      const existingValue = values.find(x => compare(x, newValue));
      if (existingValue === undefined) {
        newValues.push(newValue);
      } else {
        newValues.splice(newValues.indexOf(existingValue), 1);
      }
    } else {
      const index = newValues.indexOf(newValue);
      if (index === -1) {
        newValues.push(newValue);
      } else {
        newValues.splice(index, 1);
      }
    }
  };

  const addRemoveValue = (addRemoveValues?: T | T[]) => {
    setValues(prevValues => {
      if (addRemoveValues === undefined) {
        return [];
      }
      const newValues = [...prevValues];
      if (Array.isArray(addRemoveValues)) {
        addRemoveValues.forEach(newValue => {
          addRemove(newValues, newValue);
        });
      } else {
        addRemove(newValues, addRemoveValues);
      }
      return newValues;
    });
  };

  const reset = () => {
    setValues(initial);
  };

  return [values, addRemoveValue, reset];
};
